import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ItemDashboard from './ItemDashboard.js';
import { resetList } from './DataContextProvider.js';

export default function List() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dummy, setDummy] = React.useState(0);
  const [showDeletePrompt, setShowDeletePrompt] = React.useState(false);

  const forceUpdate = () => {
    setDummy(dummy + 1);
  };

  const renameList = async () => {
    const listName = document.getElementById('listName');
    if (!listName.value) {
      alert('Enter a list name');
      return;
    }
    await fetch('/api/lists/' + id, {
      method: 'PUT',
      body: JSON.stringify({name: listName.value}),
      headers: {'Content-Type': 'application/json'},
    });
    resetList(id);
    listName.value = '';
    forceUpdate();
  };

  const editList = () => {
    navigate('/lists/' + id + '/edit')
  };

  const confirmDeleteList = () => {
    setShowDeletePrompt(true);
  };

  const deleteList = async () => {
    await fetch('/api/lists/' + id, {
      method: 'DELETE',
    });
    navigate('/lists');
  };

  const cancelDeleteList = () => {
    setShowDeletePrompt(false);
  };

  return (
    <>
      <ItemDashboard item="lists" title="List" location={'/list/' + id}>
        <Form.Control id="listName" type="text" placeholder="List name" />
        <Button variant="secondary" onClick={renameList}>Rename</Button>
        <Button variant="primary" onClick={editList}>Edit</Button>
        <Button variant="danger" onClick={confirmDeleteList}>Delete</Button>
      </ItemDashboard>
      <Modal show={showDeletePrompt} onHide={cancelDeleteList}>
        <Modal.Header closeButton>
          <Modal.Title>Delete List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure? This operation cannot be undone.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDeleteList}>Cancel</Button>
          <Button variant="danger" onClick={deleteList}>Delete List</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
